import jsCookie from 'js-cookie'

import { BM_UTM_KEYS, TUtmKey } from '../../server/types/utm.types.js'

type TBmUtmParams = Record<TUtmKey, string>

export type TUtmData = {
  // eslint-disable-next-line camelcase
  utm_campaign: string
  // eslint-disable-next-line camelcase
  utm_source: string
  // eslint-disable-next-line camelcase
  utm_medium: string
  // eslint-disable-next-line camelcase
  utm_term: string
  // eslint-disable-next-line camelcase
  utm_content: string
  // eslint-disable-next-line camelcase
  utm_campaign_first: string
  // eslint-disable-next-line camelcase
  utm_source_first: string
  // eslint-disable-next-line camelcase
  utm_medium_first: string
  // eslint-disable-next-line camelcase
  utm_term_first: string
  // eslint-disable-next-line camelcase
  utm_content_first: string
}

export const extractUtmDataFromCookies = (): TUtmData => {
  const cookieValues = getBmUtmCookies()
  const utmData: TUtmData = {
    utm_campaign: cookieValues.bm_utm_campaign,
    utm_source: cookieValues.bm_utm_source,
    utm_medium: cookieValues.bm_utm_medium,
    utm_term: cookieValues.bm_utm_term,
    utm_content: cookieValues.bm_utm_content,
    utm_campaign_first: cookieValues.bm_first_utm_campaign,
    utm_source_first: cookieValues.bm_first_utm_source,
    utm_medium_first: cookieValues.bm_first_utm_medium,
    utm_term_first: cookieValues.bm_first_utm_term,
    utm_content_first: cookieValues.bm_first_utm_content,
  }

  return utmData
}

const DEFAULT_UTM_VALUE = '(none)'
const DEFAULT_UTM_SRC_VALUE = '(direct)'

const getBmUtmCookies = (): TBmUtmParams => {
  return BM_UTM_KEYS.reduce<TBmUtmParams>((params, key) => {
    const defaultValue =
      key === 'bm_utm_source' || key === 'bm_first_utm_source'
        ? DEFAULT_UTM_SRC_VALUE
        : DEFAULT_UTM_VALUE

    const utmValue = jsCookie.get(key) ?? defaultValue

    return {
      ...params,
      [key]: utmValue,
    }
  }, {} as TBmUtmParams)
}
